import { QdsRequestDTO, IQdsRequest } from "../../entities/IQdsRequest";
import BaseInstance from "../BaseInstance";
import axios from "axios";
import environment from "../../config/environment";

// Helper funkcija za kreiranje base URL-a
const getBaseURL = () => {
  const protocol = environment.api.protocol || 'http';
  const host = environment.api.host || 'localhost';
  const port = (window as any)._env_?.API_PORT || environment.api.port;

  if (port) {
    return `${protocol}://${host}:${port}`;
  }
  return `${protocol}://${host}`;
};

const DigitalSignatureQualifiedGateway = {

  getQdsRequestById: async (id: string): Promise<IQdsRequest> => {
    return BaseInstance.get(`/qds-request/${id}?include=createdBy`);
  },

  getQdsSignatureById: async (data: { email: string; token: string }) => {
    const baseURL = getBaseURL();

    return axios.get(`${baseURL}/qds-request/qdssignature`, {
      params: data,
    });
  },

  createQdsRequest: async (payload: QdsRequestDTO) => {
    const payloadToSend: QdsRequestDTO = {
      ...payload,
    };

    return BaseInstance.post("/qds-request", payloadToSend);
  },
  deleteQdsRequest: async (id: number) => {
    return BaseInstance.delete(`/qds-request/${id}`);
  },
  approveConsent: async (qdsRequestId: number, userId: number) => {
    return BaseInstance.put(`/qds-request/${qdsRequestId}/consents`, {
      userId,
      status: "approved",
    });
  },
  rejectConsent: async (qdsRequestId: number, userId: number) => {
    return BaseInstance.put(`/qds-request/${qdsRequestId}/consents`, {
      userId,
      status: "rejected",
    });
  },
  signDocument: async (qdsRequestId: number, userId: number, status: string, file: File) => {
    const formData = new FormData();
    formData.append("userId", String(userId));
    formData.append("status", status);
    formData.append("file", file);

    return BaseInstance.put(
      `/qds-request/${qdsRequestId}/holder-signatures`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  // Web QDS Signing Methods
  getQdsWebSigningDocument: async (
    id: string,
    data: { email: string; token: string }
  ) => {
    const baseURL = getBaseURL();

    return axios.post<Blob>(`${baseURL}/qds-request/${id}/get-websigning-document`, data, {
      responseType: "blob",
    });
  },

  getDocumentForWebQdsSigningById: async (
    id: string,
    data: { email: string; token: string }
  ) => {
    const baseURL = getBaseURL();

    return axios.get(`${baseURL}/qds-request/websign/${id}`, {
      params: data,
      responseType: "blob",
    });
  },

  submitWebQdsSignedDocument: async (formData: FormData): Promise<IQdsRequest> => {
    return BaseInstance.patch("/qds-request/websign", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  resendConsentEmail: async (signatureId: number) => {
    return BaseInstance.post(`/qds-request/signature/${signatureId}/resend-consent-email`);
  },

  resendHolderSignatureEmail: async (signatureId: number) => {
    return BaseInstance.post(`/qds-request/signature/${signatureId}/resend-holder-signature-email`);
  },

  resendCounterPartyEmail: async (signatureId: number) => {
    return BaseInstance.post(`/qds-request/signature/${signatureId}/resend-counter-party-email`);
  },
  
  //   editQdsRequest: async (id: string, payload: EditViewDigitalSignatureRequestDTO) => {
  //     return BaseInstance.put(`/digital-sign-requests/${id}`, payload);
  //   },
};

export default DigitalSignatureQualifiedGateway;
